const data = {
  MD: {
    key: "MD",
    company: "MONGODB",
    position: "INTERACTION DESIGNER",
    description:
      "DS lead of the navigation redesign. Building and maintaining the LG DS.",
    image: "mongodb-icon.PNG",
    render: () => (
      <span className="portfolio-description hide-mobile">
        DS lead of the navigation
        <br />
        redesign. Building and
        <br />
        maintaining the LG DS.
      </span>
    ),
  },
  DJ: {
    key: "DJ",
    company: "DOULBE JUMP",
    position: "PRODUCT DESIGNER",
    description:
      "Spearheaded the design of the responsive MVP website + lite pages.",
    image: "double-jump-icon.PNG",
    link: "https://www.figma.com/proto/Qkq8gY3wdfzbNHyvgOBnpK/Double-Jump-Website?node-id=390-1328&t=LGvGgZGzZWHZAUMD-8&scaling=min-zoom&content-scaling=fixed&page-id=383%3A864&starting-point-node-id=390%3A1328&hide-ui=1",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Spearheaded the design of
        <br />
        the responsive MVP
        <br />
        website + lite pages.
      </span>
    ),
  },
  BP: {
    key: "BP",
    company: "BLOCKPOLY",
    position: "FOUNDING DESIGNER",
    description: "Designed an MVP metaverse loan marketplace for land NFTs.  ",
    image: "blockpoly-icon.PNG",
    link: "https://www.figma.com/proto/VrPMlQrxM99VjEj7QJsTVs/BlockPoly-MVP-Wireframes?node-id=121-394&t=DGEKc1LaulrVy4YN-0&scaling=min-zoom&content-scaling=fixed&page-id=107%3A173&starting-point-node-id=121%3A173&hide-ui=1",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Designed an MVP metaverse
        <br />
        loan marketplace for land
        <br />
        NFTs.
      </span>
    ),
  },
  MC: {
    key: "MC",
    company: "MCAFEE",
    position: "PRODUCT DESIGNER",
    description: "Created a guided post-purchase download experience. ",
    image: "mcafee-icon.PNG",
    link: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-Portfolio?node-id=708-166&t=oQh0AKUJGZSwsY78-1&scaling=scale-down&content-scaling=fixed&page-id=701%3A17&starting-point-node-id=708%3A166",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Created a guided post-
        <br />
        purchase download
        <br />
        experience.
      </span>
    ),
  },
  GI: {
    key: "GI",
    company: "GOINVO",
    position: "UX DESIGNER",
    description: "Built a patient timeline feature + ASD task app.",
    image: "goinvo-icon.PNG",
    link: "https://www.figma.com/proto/E0kwaxs7bhvX55MwW2yicg/2025-SN-Portfolio?node-id=765-24137&t=0altw4P1nNJST76X-1&scaling=scale-down&content-scaling=fixed&page-id=701%3A17&starting-point-node-id=765%3A24137",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Built a patient timeline
        <br />
        feature + ASD task app.
      </span>
    ),
  },
  AM: {
    key: "AM",
    company: "AEROMATES",
    position: "UX/UI DESIGNER",
    description: "Designed the iOS and web MVP of the aviation marketplace.",
    image: "aeromates-icon.PNG",
    link: "https://www.linkedin.com/company/aeromates/about/",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Designed the iOS and web
        <br />
        MVP of the aviation
        <br />
        marketplace.
      </span>
    ),
  },
  HG: {
    key: "HG",
    company: "HAUS OF GOLF",
    position: "GRAPHIC DESIGNER",
    description:
      "Conceptualized brand identity through style guides and logo design.",
    image: "haus-of-golf-icon.PNG",
    link: "https://www.facebook.com/HausofGolf",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Conceptualized brand
        <br />
        identity through style
        <br />
        guides and logo design.
      </span>
    ),
  },
  VR: {
    key: "VR",
    company: "VRILLAR",
    position: "UX DESIGNER",
    description: "Designed the user interface for an NFT marketplace.",
    image: "vrillar-icon.PNG",
    link: "https://vrillar.com/?ckattempt=2",
    render: () => (
      <span className="portfolio-description hide-mobile">
        Designed the user
        <br />
        interface for an NFT
        <br />
        marketplace.
      </span>
    ),
  },
};

export default data